module.exports = __webpack_public_path__ + "static/img/appQR.708f233.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/appQR.png
// module id = O+Am
// module chunks = 101